import { loginUserInfo } from '../api/requests';
import { State } from '../state';

export const AuthenticationSelectors = {
    forgotPassword: (state: State) => state.Authentication.forgotPassword,
    passwordVerification: (state: State) => state.Authentication.verifyResetCode,
    password: (state: State) => state.Authentication.setPassword,
    login: (state: State) => state.Authentication.login,
    loginUserInfo: (state: State) => state.Authentication.loginUserInfo,
};
